import operationVesselService from "@/services/operations/operationVesselService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";
import has from "lodash/has";
import mapKeys from "lodash/mapKeys";

const INITIAL_STATE = {
  operationVessels: [
    // {
    //   "disabled_at": "2024-03-18T05:44:17.649Z",
    //   "id": "string", // NOTE: enterprise_vessel_id
    //   "permission_level": 0,
    //   "sort_order": 0,
    //   "vessel": {
    //     "call_sign": "string",
    //     "certificate_number": "string",
    //     "country_code": {
    //       "id": "string"
    //     },
    //     "id": "string",
    //     "identification_number": "string",
    //     "imo": "string",
    //     "mmsi": "string",
    //     "name": "string",
    //     "name_ja": "string",
    //     "status": 0,
    //     "vessel_ais_info": {
    //       "call_sign": "string",
    //       "dim_bow": 0,
    //       "dim_port": 0,
    //       "dim_starboard": 0,
    //       "dim_stern": 0,
    //       "full_draft": 0,
    //       "imo": "string",
    //       "length_overall": 0,
    //       "mmsi": "string",
    //       "name": "string",
    //       "width": 0
    //     },
    //     "vessel_category": {
    //       "id": "string"
    //     },
    //     "vessel_pictures": [
    //       {
    //         "id": "string",
    //         "original_path": "string",
    //         "thumbnail_path": "string"
    //       }
    //     ],
    //     "vessel_size": {
    //       "dim_bow": 0,
    //       "dim_port": 0,
    //       "dim_starboard": 0,
    //       "dim_stern": 0,
    //       "full_draft": 0,
    //       "gt": 0,
    //       "length_overall": 0,
    //       "width": 0
    //     }
    //   }
    // }
  ],
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    /**
     * operation vessel 設定をセットするミューテーション
     *
     * @param {Object} state - Vuex ストアの状態オブジェクト
     * @param {OperationVessel[]} data - データ
     * @returns {void}
     */
    SET_OPERATION_VESSELS(state, data) {
      state.operationVessels = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * operation vessel 設定 を storeにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationVessels({ commit }) {
      const operationVessels = await operationVesselService.getOperationVessels();
      commit("SET_OPERATION_VESSELS", operationVessels.data || []);
      operationLocalDbService.setOperationVesselsToLocalDB(
        operationVessels.data || []
      );
    },

    /**
     * operation vessel 設定  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationVesselsFromLocalDB({ commit }) {
      const operationVessels = await operationLocalDbService.getOperationVesselsFromLocalDB();
      commit("SET_OPERATION_VESSELS", operationVessels || []);
    },

    /**
     * operation vessel 設定  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationVesselsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setOperationVesselsFromLocalDB");
      if (!getters.hasOperationVessels) {
        dispatch("setOperationVessels");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    // OperationVessel[]
    validOperationVessels({ operationVessels }) {
      if (!Array.isArray(operationVessels)) return [];
      return operationVessels.filter(
        oa => operationVesselService.isOperationVessel(oa) // オブジェクトの１階層目のみチェック
      );
    },

    operationVesselMapByEnterpriseVesselId(_, { validOperationVessels }) {
      if (!Array.isArray) return {};
      return mapKeys(
        validOperationVessels,
        "id" // id は enterprise_vessel_id に対応
      );
    },

    hasOperationVessels(_, { validOperationVessels }) {
      return (
        has(validOperationVessels, "length") && validOperationVessels.length > 0
      );
    },
  },
};
